import {
  COOKIE_AUTH_USER,
  COOKIE_UPDATED_COOKIES
} from '@wiggot/auth/constants/cookies'
import { createCookie } from '@wiggot/auth/utils/cookies'
import { getCookieUpdateCookies } from '@wiggot/auth/services/token-service'
import type { IAuthUser } from '../../interfaces/src/user.interface'

const STAGE = process.env.NEXT_PUBLIC_STAGE ?? ''

export const updateCookieAuth = (
  currentAuthUser: IAuthUser,
  newAuthUser: IAuthUser
): IAuthUser => {
  const newValueAuthUser: IAuthUser = {
    ...currentAuthUser,
    ...newAuthUser
  }

  const expirationDate = new Date()

  expirationDate.setDate(expirationDate?.getDate() + 365)

  const formattedDate = expirationDate?.toUTCString()

  const valueUpdateCookies = getCookieUpdateCookies()

  const date = new Date().toUTCString()

  const newValueUpdateCookies = valueUpdateCookies
    ? [
        ...valueUpdateCookies.filter(
          (cookie) => cookie.name !== COOKIE_AUTH_USER
        ),
        { name: COOKIE_AUTH_USER, lastUpdated: date }
      ]
    : [
        {
          name: COOKIE_AUTH_USER,
          lastUpdated: date
        }
      ]

  createCookie({
    name: COOKIE_UPDATED_COOKIES,
    value: JSON.stringify(newValueUpdateCookies),
    date: formattedDate,
    httpOnly: false,
    secure: STAGE !== 'local'
  })

  createCookie({
    name: COOKIE_AUTH_USER,
    value: JSON.stringify(newValueAuthUser),
    date: formattedDate,
    httpOnly: false,
    secure: STAGE !== 'local'
  })

  return newValueAuthUser
}
